/**
 * Returns the URL of Medly Exams for platform switching.
 *
 * Resolution order:
 * 1. NEXT_PUBLIC_EXAMS_URL env var (set per deployment environment)
 * 2. Localhost fallback (for local dev with port-based routing)
 * 3. Production URL
 */
export function getSiblingAppUrl(): string {
  if (process.env.NEXT_PUBLIC_EXAMS_URL) {
    return process.env.NEXT_PUBLIC_EXAMS_URL;
  }

  const host = window.location.hostname;
  const isLocal =
    host === "localhost" ||
    host === "127.0.0.1" ||
    /^(10|192\.168|172\.(1[6-9]|2\d|3[01]))\./.test(host);

  return isLocal ? `http://${host}:3000` : "https://app.medlyai.com";
}
